import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'
import { useLoadProgress } from '../hooks/useLoadProgress'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
  // 暫存需加
  userId,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 暫存需加
  const [isReady, setIsReady] = useState(false)
  const userIdRef = useRef(null)
  useEffect(() => {
    if (userId) userIdRef.current = userId
  }, [userId])

  // 需要登入嗎
  const requiresLogin = {
    login: true,
    title: '驗證碼',
    placeholder: '請輸入驗證碼',
    alert: '請檢查網址是否帶入正確編號',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = null

  // const bringOptionsMapRef = useRef({})
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  //受僱者
  const Employee = '({q7} = 0 or {q8} = 0)'
  //自僱者
  const selfEmployed = '({q7} = 1 or {q8} = 1)'

  const visibleIfConditionsInit = {
    q3: '{q2} = 1',
    q4: '{q2} = 1',
    q8: '{q7} = 2 or {q7} = 3',
    q9: '{q7} = 1 or ({q7} = 2 and {q8} = 1) or ({q7} = 3 and {q8} = 1)',
    q10: Employee,
    q11: Employee,
    q12: Employee + ' and ({q11} = 1 or {q11} = 2)',
    q13: Employee + ' and (({q11} = 1 or {q11} = 2) and {q12} = 0)',
    q14: Employee + ' and (({q11} = 1 or {q11} = 2) and {q12} = 1)',
    q15: Employee + ' and (({q11} = 1 or {q11} = 2) and {q12} = 2)',
    q16: Employee,
    q17: '{q16} = 0',
    q18: '{q16} = 0 and {q17} = 0',
    q19: '{q16} = 0 and {q17} = 1',
    q20: '{q16} = 1 or {q16} = 2 or ({q16} = 0 and {q17} = 2) or ({q16} = 0 and {q17} = 3)',
    q24: '{q23} = 1 or {q23} = 2 or {q23} = 3 or {q23} = 4 or {q23} = 5 or {q23} = 6 or {q23} = 7 or {q23} = 8 or {q23} = 9',
    q26: '{q25} = 0',
    q27: '{q25} = 0 or {q25} = 1 or {q25} = 2 or {q25} = 3',
    q29: '{q28} = 0',
    q30: '{q28} = 1',
    q31: '({q2} = 1) and ({q3} = 0 or {q3} = 2)',
    q32: '{q31} = 0',
    q33: '{q31} = 1',
    q35: '{q34} = 0',
    q36: '{q34} = 1',
    q38: '{q1} = 0 or {q1} = 4 or {q1} = 6 or {q1} = 7',
    q39: '{q1} = 1 or {q1} = 2 or {q1} = 8 or {q1} = 11',
    q40: '{q1} = 3 or {q1} = 5 or {q1} = 9 or {q1} = 10',
    q41: '{q1} = 4 or {q1} = 5 or {q1} = 6 or {q1} = 7',
    q42: '{q1} = 0 or {q1} = 1 or {q1} = 2 or {q1} = 3',
    q43: '{q1} = 8 or {q1} = 9 or {q1} = 10 or {q1} = 11',
    q44: Employee,
    q45: selfEmployed,

    q51: '{q44} = 0 or {q44} = 1 or {q45} = 0 or {q45} = 1 or {q46} = 0 or {q46} = 1 or {q49} = 0 or {q49} = 1',
    q52: '{q48} = 0 or {q48} = 1 or {q48} = 2',
    q53: '{q50} = 1',
    q54: '{q48} = 1 or {q48} = 2 or {q48} = 3 or {q48} = 4 or {q48} = 5 or {q48} = 6',

    q55: '{q54} = 0 or {q54} = 1 or {q54} = 2 or {q54} = 3 or {q54} = 5 or {q54} = 6 or {q54} = 7',
    q56: '{q55} = 0',
    q57: '{q55} = 1',
    q58: '{q55} = 2 or {q56} > 0 or {q57} > 0',
    q65: '{q64} = 0',
    q67: '{q66} = 0 or {q66} = 1',
    q70: '{q0} = 0 or {q0} = 2 or {q0} = 4',
    q71: `{q0} = 1 or {q0} = 3 or {q0} = 'other'`,
    q72: Employee,

    q82: '({q7} = 0 or {q8} = 0) and ({q76} = 0 or {q76} = 1 or {q76} = 2 or {q76} = 3 or {q76} = 4 or {q76} = 5 or {q77} = 0 or {q77} = 1 or {q77} = 2 or {q77} = 3 or {q77} = 4 or {q77} = 5 or {q78} = 0 or {q79} = 0 or {q80} = 0 or {q81} = 0)',
    q83: '{q76} = 0 or {q76} = 1 or {q76} = 2 or {q76} = 3 or {q76} = 4 or {q76} = 5 or {q77} = 0 or {q77} = 1 or {q77} = 2 or {q77} = 3 or {q77} = 4 or {q77} = 5 or {q78} = 0 or {q79} = 0 or {q80} = 0 or {q81} = 0',
    q87: '{q84} = 0 or {q84} = 1 or {q85} = 0 or {q85} = 1 or {q86} = 0 or {q86} = 1',
    q90: '{q1} = 0 or {q1} = 2 or {q1} = 4 or {q1} = 6 or {q1} = 8 or {q1} = 10',
    q91: '{q1} = 1 or {q1} = 3 or {q1} = 5 or {q1} = 7 or {q1} = 9 or {q1} = 11',
    q93: '{q92} = 0 or {q92} = 1 or {q92} = 2',
    q96: selfEmployed,

    q97: Employee + ' and ({q1} = 2 or {q1} = 6 or {q1} = 9 or {q1} = 10)',
    q98: Employee + ' and ({q1} = 1 or {q1} = 4 or {q1} = 5 or {q1} = 11)',
    q99: Employee + ' and ({q1} = 0 or {q1} = 3 or {q1} = 7 or {q1} = 8)',
    q100: selfEmployed + ' and ({q1} = 2 or {q1} = 6 or {q1} = 9 or {q1} = 10)',
    q101: selfEmployed + ' and ({q1} = 1 or {q1} = 4 or {q1} = 5 or {q1} = 11)',
    q102: selfEmployed + ' and ({q1} = 0 or {q1} = 3 or {q1} = 7 or {q1} = 8)',

    // ========================================= Q65 縮題(扣 14 題) =============================
    // Q66
    q103: Employee,
    q104: '({q0} = 0 or {q0} = 1 or {q0} = 2) and ({q103} = 0 or {q103} = 1 or {q103} = 2)',
    q105: `({q0} = 3 or {q0} = 4 or {q0} = 'other') and ({q103} = 0 or {q103} = 1 or {q103} = 2)`,

    // Q71
    q109: Employee,
    q110: selfEmployed,
    q112: '{q109} = 1',
    q113: '{q109} = 0 or {q110} = 0 or {q111} = 0',
    q115: '{q114} = 0',
    q116: '({q1} = 0 or {q1} = 1 or {q1} = 2 or {q1} = 3 or {q1} = 4 or {q1} = 5) and ({q115} = 0 or {q115} = 1)',
    q117: '({q1} = 6 or {q1} = 7 or {q1} = 8 or {q1} = 9 or {q1} = 10 or {q1} = 11) and ({q115} = 0 or {q115} = 1)',
    // Q77
    q118: '({q114} = 0)',
    q119:
      '({q1} = 0 or {q1} = 2 or {q1} = 4 or {q1} = 6 or {q1} = 8 or {q1} = 10) and ' +
      Employee,
    q120:
      '({q1} = 1 or {q1} = 3 or {q1} = 5 or {q1} = 7 or {q1} = 9 or {q1} = 11) and ' +
      Employee,
    q121: '({q0} = 0 or {q0} = 2 or {q0} = 4) and ' + Employee,
    q122: `({q0} = 1 or {q0} = 3 or {q0} = 'other') and ` + Employee,
    q126: '{q125} = 0 or {q125} = 1',
    q127: '{q0} = 0 or {q0} = 1 or {q0} = 2',
    q128: `{q0} = 3 or {q0} = 4 or {q0} = 'other'`,
    // Q87
    q132: '{q131} = 0',
    q138: '({q7} = 0 or {q8} = 0) and ({q125} = 0 or {q126} = 0 or {q126} = 1 or {q129} = 0)',
    q139: Employee,
    q140: '{q1} = 0 or {q1} = 2 or {q1} = 4 or {q1} = 6 or {q1} = 8 or {q1} = 10',
    q141: '{q1} = 1 or {q1} = 3 or {q1} = 5 or {q1} = 7 or {q1} = 9 or {q1} = 11',

    // ========================================= Q96 縮題(扣 17 題) =============================
    // Q96
    q142: Employee + ' and ({q1} = 2 or {q1} = 5 or {q1} = 6 or {q1} = 9)',
    q143: Employee + ' and ({q1} = 0 or {q1} = 3 or {q1} = 4 or {q1} = 8)',
    q144: Employee + ' and ({q1} = 1 or {q1} = 7 or {q1} = 10 or {q1} = 11)',
    q145: selfEmployed + ' and ({q1} = 2 or {q1} = 5 or {q1} = 6 or {q1} = 9)',
    q146: selfEmployed + ' and ({q1} = 0 or {q1} = 3 or {q1} = 4 or {q1} = 8)',
    q147:
      selfEmployed + ' and ({q1} = 1 or {q1} = 7 or {q1} = 10 or {q1} = 11)',

    // Q97
    q148: '{q0} = 0 or {q0} = 2 or {q0} = 4',
    q149: `{q0} = 1 or {q0} = 3 or {q0} = 'other'`,
    q152: Employee,
    q155: '{q154} = 4 or {q154} = 5 or {q154} = 6 or {q154} = 7',
    q156: '{q154} = 0 or {q154} = 1 or {q154} = 2 or {q154} = 3',
    // Q104
    q157: '{q154} = 4 or {q154} = 5 or {q154} = 6 or {q154} = 7 or {q154} = 8 or {q154} = 9',
    q161: '{q158} = 0',
    // Q106A1
    q162: '{q158} = 0 and {q161} = 0',
    q163: '{q158} = 0 and {q161} = 1',
    q164: '{q159} = 0',
    // Q106B1
    q165: '{q159} = 0 and {q164} = 0',
    q166: '{q159} = 0 and {q164} = 1',
    q167: '{q160} = 0',
    // Q106C1
    q168: '{q160} = 0 and {q167} = 0',
    q169: '{q160} = 0 and {q167} = 1',
    q170: '{q158} = 1 or {q158} = 2',
    // Q107A1
    q171: '({q158} = 1 or {q158} = 2) and {q170} = 0',
    q172: '({q158} = 1 or {q158} = 2) and {q170} = 1',
    q173: '{q159} = 1 or {q159} = 2',
    // Q107B1
    q174: '({q159} = 1 or {q159} = 2) and {q173} = 0',
    q175: '({q159} = 1 or {q159} = 2) and {q173} = 1',
    q176: '{q160} = 1 or {q160} = 2',
    // Q107C1
    q177: '({q160} = 1 or {q160} = 2) and {q176} = 0',
    q178: '({q160} = 1 or {q160} = 2) and {q176} = 1',
    // Q110
    q182: Employee,
    q184: selfEmployed,
    q186: '{q185} = 0',
    q187: '{q185} = 1',
    q188: '{q185} = 2',
    q189: '{q185} = 3 or {q185} = 4',
    q190: '{q189} = 0',
    q191: '{q189} = 1',
    q192: '{q189} = 2',
    // Q116A
    q194: `{q193} = 'other'`,
    q195: `{q193} = 'other'`,
    q196: `{q193} = 'other'`,
    q197: `{q193} = 'other'`,
    q198: `{q193} = 'other'`,
    q199: `{q193} = 'other'`,
    q200: `{q193} = 'other'`,
    q201: `{q193} = 'other'`,
    q202: `{q193} = 'other'`,
    q203: `{q193} = 'other'`,
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    // {
    //   type: 'complete',
    //   expression: `({q1} = 1) or ({q2} = 0)`,
    // },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    // bringOptionsMapRef,
    // 暫存需加
    userIdRef,
    // userId
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  const otherAnswersRef = useRef({})
  const noneAnswersRef = useRef({})
  const matrixAnswersRef = useRef({})
  const timestampsRef = useRef({})

  useLoadProgress({
    surveyModel: surveyModel, // 若 myAgreeJson 為 null，agreeSurvey 亦為 null
    convertedSurvey: myAgreeJson,
    isReady,
    requiresLogin,
    setIsLoading,
    pid,
    ac,
    tk,
    choiceIndexMapRef,
    choicesOrderRef,
    bringOptionsMapRef,
    otherAnswers: otherAnswersRef.current,
    noneAnswers: noneAnswersRef.current,
    matrixAnswers: matrixAnswersRef.current,
    timestamps: timestampsRef.current,
  })

  // SurveyModel 初始化完成 → 標記可互動
  useEffect(() => {
    if (agreeSurvey) {
      const id = setTimeout(() => setIsReady(true), 50)
      return () => clearTimeout(id)
    }
  }, [agreeSurvey])

  // 設置 survey 準備就緒狀態
  useEffect(() => {
    if (surveyModel) {
      // 給 survey 一些時間完成初始化
      setTimeout(() => {
        setIsReady(true)
      }, 50)
    }
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  // const endMessage = `很抱歉，目前與您相同特性的樣本已經額滿，沒辦法參與本次活動。歡迎您分享本問卷連結給其他親朋好友，或加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q42'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  // const endSurveyMsg = (survey) => {
  //   if (survey.getValue('q1') === 1 || survey.getValue('q2') === 0) {
  //     setCompletionMessage(endMessage)
  //   } else {
  //     setCompletionMessage(
  //       `<h4 style='text-align: center'>問卷已成功送出</h4><h4 style='text-align: center'>請按「完成」前往下載 EZChoice 或填寫更多問卷</h4>`
  //     )
  //   }
  // }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    // endSurveyMsg,
    // bringOptionsMapRef,
    // 暫存需加
    requiresLogin,
    userIdRef, // 傳入 ref 而不是直接傳 userId
    enableProgressSaving: requiresLogin.login, // 根據登入需求啟用
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
